import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/platform-browser';

import { AngularFirestore, AngularFirestoreDocument } from 'angularfire2/firestore';
import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase/app';
import { AppUser, AclUser } from '../interfaces/app-user';
import { GoogleApiService, GoogleAuthService } from 'ng-gapi';
import GoogleUser = gapi.auth2.GoogleUser;

import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/first';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/timeout';
import 'rxjs/add/observable/combineLatest';
import 'rxjs/add/observable/from';
import { Subject } from 'rxjs/Subject';
import { ReplaySubject } from 'rxjs/ReplaySubject';

// const CUSTOMER_DOMAIN = 'extravega.com'; // TODO Get this form URL !!!!!!!
const CUSTOMER_COLLECTION = 'Customers';

function getDomain(hostName) {
  let domain = hostName;

  if (hostName != null) {
    const parts = hostName.split('.').reverse();

    if (parts != null && parts.length > 1) {
      domain = parts[1] + '.' + parts[0];

      if (hostName.toLowerCase().indexOf('.co.uk') !== -1 && parts.length > 2) {
        domain = parts[2] + '.' + domain;
      }
    }
  }

  return domain;
}

interface Role {
  permissions: Set<string>;
}

@Injectable()
export class AuthService {

  // Google Auth
  public static SESSION_STORAGE_KEY = 'accessToken';
  private googleUser: GoogleUser;

  // Domain
  private readonly CUSTOMER_DOMAIN;

  public isLoggedIn = false;

  // store the URL so we can redirect after logging in
  public redirectUrl: string;
  public userStream$: Observable<AppUser>;
  public auth2: any;

  private _loggedUser = new ReplaySubject<AppUser>(1);
  private errorCodes = {
    authenticationFailed: 'authenticationFailed',
    serverError: 'serverError'
  };

  // private currentUser: any;
  private user: Observable<firebase.User>;

  private userColRef;

  private permissions = {};
  private _provider;
  // private _currentAppUser: AppUser;
  private _currentUser: AppUser;
  private isUserSet = false;

  private permission = new ReplaySubject<Set<string>>(1);
  private permissionsSubscription;

  private readonly cDR: AngularFirestoreDocument<any>;

  get provider() {
    return this._provider;
  }

  // get currentAppUser(): AppUser {
  //   return this._currentAppUser;
  // }

  // BE CAREFUL CAN BE undefined
  get currentUser(): AppUser {
    return this._currentUser;
  }

  get customerDocumentReference() {
    return this.cDR;
  }

  get appDomain() {
    return this.CUSTOMER_DOMAIN;
  }

  constructor(
    @Inject(DOCUMENT) private document,
    private firebaseAuth: AngularFireAuth,
    private afs: AngularFirestore,
    private googleAuth: GoogleAuthService,
    private router: Router) {

    console.log('hostname', document.location.hostname);
    let domain = getDomain(document.location.hostname);



    if (document.location.hostname === 'evtest.wonder-sys.com' || document.location.hostname === 'tistest.wonder-sys.com') {
      domain = 'theitalianspace.com';
    }

    if (document.location.hostname === 'wondersys.app.dev.wonderbudget.com') {
      domain = 'extravega.com';
    }

    // For testing
    
    if (domain === 'localhost') {
      domain = 'wonder-sys.com';
      // domain = 'extravega.com';
      //domain = 'theitalianspace.com';
    }
    this.CUSTOMER_DOMAIN = domain;
    console.log('domain', this.CUSTOMER_DOMAIN);

    // let u = new User(null); // anonoymus
    this.user = firebaseAuth.authState;
    if (!this.user) {
      // HANDLE THIS!!!
      console.error('Fireauth User is NULL ', this.user);
    } else {
      console.log('Fireauth User ', this.user);
    }

    this._provider = new firebase.auth.GoogleAuthProvider();
    // Add scopes
    this._provider.addScope('https://www.googleapis.com/auth/contacts.readonly');


    // this._loggedUser = new BehaviorSubject<AppUser>(null);

    // // Workaround to avoid return a null user
    // this.userStream$ = this._loggedUser.asObservable().filter((x) => this.isUserSet)
    //   .do((u) => this._currentAppUser = u);

    this.cDR = this.afs.collection(CUSTOMER_COLLECTION).doc(this.CUSTOMER_DOMAIN);
    console.log('cDR', this.cDR.ref.path);
    // ACL on FIRESTORE
    this.userColRef = this.cDR
      .collection<AclUser>('Users', ref => ref.where('active', '==', true).where('deleted', '==', false));

    // this.user.first().subscribe((u) => {
    //   console.log('First user', u);
    //   this.isUserSet = true;
    // });

    Observable.combineLatest(
      googleAuth.getAuth(),
      this.user,
      this.userColRef.valueChanges(), // .do((ulist) => console.log('User List', ulist)),
      (auth: gapi.auth2.GoogleAuth, u: firebase.User, acl: AclUser[]) => {

        // Controlla Google Auth
        const gUser = auth.currentUser.get();
        const guidFromGoogle = gUser.getId();
        console.log('guidfg', guidFromGoogle);

        /*************
         * QUI VA IL CONTROLLO DEL RUOLO
         */
        let au: AppUser = null;
        if (u) {
          const uGoogleData = u.providerData.find((pd) => pd.providerId === 'google.com');
          if (uGoogleData) {
            if (uGoogleData.uid !== guidFromGoogle) {
              // TODO Handle This!!!
              console.log('We need to authenticate again');
              firebase.auth().signOut().then(p => { this.router.navigate(['/home']); });
              return null;
            }

            const appUser = acl.find((i) => i.googleUid === uGoogleData.uid);
            if (appUser) {
              au = <AppUser>u;
              au.role = appUser.role;
              au.googleUid = uGoogleData.uid;
              au.googleUser = gUser;
              au.initials = appUser.initials;
              au.type = appUser.type;
            }
          }
        }
        console.log('Auth Service constructor. Current User is', au);
        return au;
      })
      .do((u) => this._currentUser = u )
      .subscribe(this._loggedUser);

      this.userStream$ = this._loggedUser.asObservable();


      // Once the user is logged load permissions
      this.permissionsSubscription = this._loggedUser
      .switchMap((u) => {
        if (!u) {
          return Observable.of(new Set([]));
        }
        const oArray = [];
        if (!u.type) {
          u.type = [];
        }
        u.type.forEach(role => {
          console.log('User has role', role);
          /** ISSUE!!
           * Roles can be accessed only by authenticated users on firestore.
           * This mean we need to unsubscribe as soon as the user logout to avoid missing permission error
          */
          oArray.push(this.cDR.collection<Role>('Roles').doc<Role>(role).valueChanges()
          .map((r) => r ? r.permissions : []));
        });
        return Observable.combineLatest(oArray, (...rPerms) => new Set([].concat(...rPerms)));
      }).subscribe(this.permission);
      // .do((allPerm) => { console.log('all perm', allPerm); })
      // .subscribe((allPerm) => {
      //   this._currentAppUser.permissions = allPerm;
      //   console.log('User with perm', this._currentAppUser);
      // });


  }



  // Pure Google Auth
  public getGoogleToken(): string {
    const token: string = sessionStorage.getItem(AuthService.SESSION_STORAGE_KEY);
    if (!token) {
      throw new Error('no token set , authentication required');
    }
    return sessionStorage.getItem(AuthService.SESSION_STORAGE_KEY);
  }

  public signInWithGoogle(): void {
    this.googleAuth.getAuth()
      .subscribe((auth) => {
        auth.signIn().then(res => this.signInSuccessHandler(res));
      });
  }

  private signInSuccessHandler(res: GoogleUser) {
    this.googleUser = res;

    const credential = firebase.auth.GoogleAuthProvider.credential(
      this.googleUser.getAuthResponse().id_token);
    firebase.auth().signInWithCredential(credential)
      .then((pData) => {
        this.router.navigate(['/budget']);
      });

    console.log('Google User', res);
    sessionStorage.setItem(
      AuthService.SESSION_STORAGE_KEY, res.getAuthResponse().access_token
    );
  }

  // End Pure Goole Auht

  public getUserIdToken = () => {
    return this.userStream$.switchMap((u) => Observable.from(u.getIdToken()))
      .catch((err) => {
        console.warn('Error tring to get token ID: ', err);
        return Observable.of(null);
      });
  }

  public logout() {
    return firebase.auth().signOut();
  }

  private validateAuthResponse(responseData): boolean {
    return true;
  }

  private handleError(error: Response | any) {
    console.log('RESPONSE ERROR', error);
    this.isLoggedIn = false;
    return Observable.of(false);
  }

  // HANDLE PERMISSIONS

  // /** @deprecated */
  // public canSeeFigures = function () {
  //   return (this.currentAppUser.type.indexOf('admin') > -1 ||
  //     this.currentAppUser.type.indexOf('cto') > -1 ||
  //     this.currentAppUser.type.indexOf('prjmgr') > -1 ||
  //     this.currentAppUser.type.indexOf('finmgr') > -1);
  // };

  // /** @deprecated */
  // public canOpenProject = function () {
  //   return (this.currentAppUser.type.indexOf('admin') > -1 ||
  //     this.currentAppUser.type.indexOf('finmgr') > -1);
  // };

  // public userHasPermission = (permission: string) => {
  //   if (!permission) {
  //     return false;
  //   }
  //   if (!this.currentAppUser || !this.currentAppUser.permissions) {
  //     return false;
  //   }
  //   return this.currentAppUser.permissions.has(permission);
  // }

  public userHasPermission = (permission: string) => {
    return this.permission.map((permSet) => {
      return permSet.has(permission);
    });
  }

  public userHasPermissions = (permissions: string[]) => {
    return this.permission.map((permSet) => {
      const ret = [];
      for (const p of permissions) {
        ret.push(permSet.has(p));
      }
      return ret;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/services/auth.service.ts